import axios from '@/http/index';

const base = '';
export default {
  // 获取 顾客分析
  getAnalyse(params) {
    return axios.get(`${base}/erp/analyse/getAnalyse`, params).then((res) => res.data);
  },
  // 获取 房间预订
  getBookRoom(params) {
    return axios.get(`${base}/erp/situation/getBookRoom`, params).then((res) => res.data);
  },
  // 获取 预约项目
  getBookServe(params) {
    return axios.get(`${base}/erp/situation/getBookServe`, params).then((res) => res.data);
  },
  // 获取 预约项目详情
  getBookServeDetails(params) {
    return axios.get(`${base}/erp/situation/getBookServeDetails`, params).then((res) => res.data);
  },
  // 获取 预约概况
  getBookSituation(params) {
    return axios.get(`${base}/erp/situation/getBookSituation`, params).then((res) => res.data);
  },
  // 获取 预约来源
  getBookSource(params) {
    return axios.get(`${base}/erp/situation/getBookSource`, params).then((res) => res.data);
  },
  // 获取 预约统称
  getBookTechnician(params) {
    return axios.get(`${base}/erp/situation/getBookTechnician`, params).then((res) => res.data);
  },
  // 获取 预约统称详情
  getBookTechnicianDetails(params) {
    return axios.get(`${base}/erp/situation/getBookTechnicianDetails`, params).then((res) => res.data);
  },
  // 获取 预约技师分析
  getTechnicianBook(params) {
    return axios.get(`${base}/erp/situation/getTechnicianBook`, params).then((res) => res.data);
  },
  // 获取 预约技师分析详情
  getTechnicianBookDetail(params) {
    return axios.get(`${base}/erp/situation/getTechnicianBookDetail`, params).then((res) => res.data);
  },
  // 获取 预约明细
  getBookDetails(params) {
    return axios.get(`${base}/erp/situation/getBookDetails`, params).then((res) => res.data);
  },
  // 5.6房间预定详情
  getRoomDetail(params) {
    return axios.get(`${base}/erp/situation/getRoomDetail`, params).then((res) => res.data);
  },

  // 5.10 台位预定信息
  getBookRoomBed(params) {
    return axios.get(`${base}/erp/situation/getBookRoomBed`, params).then((res) => res.data);
  },
  // 5.10 台位预定详情
  getRoomBedDetail(params) {
    return axios.get(`${base}/erp/situation/getRoomBedDetail`, params).then((res) => res.data);
  },
};
